<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bf3"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('vehicleInsurance_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('vehicleInsurance_add_button')"
          @click="showModel(false, 'Add')"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('vehicleInsurance_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      export-config
      :sort-config="{ remote: true }"
      show-overflow
      align="center"
      :loading="loading"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="trailerNum"
          title="挂车号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.trailerNum"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="strongInsurance"
          title="交强险"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.strongInsuranceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.strongInsuranceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLossInsurance"
          title="车辆损失险"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.vehicleLossInsuranceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.vehicleLossInsuranceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="thirdPartyLiabilityInsurance"
          title="第三者责任险"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.thirdPartyLiabilityInsuranceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.thirdPartyLiabilityInsuranceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="personnelInsurance"
          title="人员险"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.personnelInsuranceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.personnelInsuranceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="nonDeductibleInsurance"
          title="不计免赔特约险"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.nonDeductibleInsuranceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.nonDeductibleInsuranceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="insuranceAmount"
          title="合计金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.insuranceAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.insuranceAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleTax"
          title="车船税"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.vehicleTaxStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.vehicleTaxEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="liabilityInsurance"
          title="责任险"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.liabilityInsuranceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.liabilityInsuranceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="commercialCompany"
          title="商业险保险公司"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.commercialCompany"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="compulsoryCompany"
          title="交强险投保公司"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.compulsoryCompany"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="liabilityCompany"
          title="责任险投保公司"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.liabilityCompany"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="liabilityDueDate"
          title="责任险到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.liabilityDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value, 'liabilityDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="compulsoryDueDate"
          title="交强险到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.compulsoryDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value, 'compulsoryDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="commercialDueDate"
          title="商业险到期日期"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.commercialDueDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value, 'commercialDueDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="(value) => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        title="操作"
        
        fixed="right"
        min-width="140"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('vehicleInsurance_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="(code) => showModel(scope.row.code, 'Edit')"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('vehicleInsurance_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="800"
      height="800"
      resize
    >
      <compAdd
        ref="AddRef"
        :restaurants="restaurants"
        @hideModel="hideModel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="800"
      height="800"
      resize
    >
      <compEdit
        ref="EditRef"
        :restaurants="restaurants"
        @hideModel="hideModel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/vehicleInsuranceAdd.vue";
import compEdit from "./components/vehicleInsuranceEdit.vue";
import { vehicleInsurance, delVehicleInsurance } from "@/api/vehicleService";
import { vehicle } from "@/api/transport";
export default {
  name: "Parent",
  components: {
    compAdd,
    compEdit,
  },
  data() {
    return {
      exportObj:{
        exportUrl:"/ntocc-basic-api/vehicleInsurance/exportVehicleInsuranceList",//导出接口
        name:'车辆保险'
      },
      loading: false,
      tableData: [],
      restaurants: [],
      modelAddFlag: false,
      modelEditFlag: false,
      partyType: this.$store.getters.party.partyType,
      partyCode: this.$store.getters.party.code,
      listQuery: {
        liabilityDueDateRange: "",
        compulsoryDueDateRange: "",
        commercialDueDateRange: "",
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
      },
    };
  },
  created() {
    if (this.partyType == "DRIVER") {
      vehicle({
        pageSize: 1000000,
        partyCode: this.partyCode,
        branchCodeExt: this.$store.state.user.party.branchCode,
      }).then((response) => {
        this.restaurants = response.data.records;
      });
    } else if (this.partyType == "DRIVER_LEADER") {
      vehicle({
        pageSize: 1000000,
        teamCode: this.partyCode,
        branchCodeExt: this.$store.state.user.party.branchCode,
      }).then((response) => {
        this.restaurants = response.data.records;
      });
    } else {
      vehicle({
        pageSize: 1000000,
        branchCodeExt: this.$store.state.user.party.branchCode,
      }).then((response) => {
        this.restaurants = response.data.records;
      });
    }
    this.findList();
  },

  methods: {
    findList() {
      this.loading = true;
      return new Promise((resolve) => {
        vehicleInsurance(this.listQuery).then((response) => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 展示弹框
    showModel(code, prefix) {
      if (code) {
        this.$refs[`${prefix}Ref`].getInfo(code);
      } else {
        this.$refs[`${prefix}Ref`].init()
      }
      this[`model${prefix}Flag`] = true;
    },
    // 隐藏弹框
    hideModel(tag) {
      this.modelAddFlag = false;
      this.modelEditFlag = false;
      if(tag) {
        this.findList();
      }
    },
    // 删除
    funcDelete(codes) {
      this.$confirm("确认删除吗？").then((_) => {
        delVehicleInsurance({ codes }).then((response) => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        }),
      ];
    },
  },
};
</script>
